export default __webpack_public_path__ + "static/apotheken-umschau-immobilienbesitzer-28e1131e59db10a0c87d8d9a8b9d3f20.png";